import { memo } from 'react'
import { State } from '../hooks/useAppState'
import Box from './Box'
import GrooverText from './GrooverText'
import iconCompleted from '/public/iconCompleted.svg'
import useAppState from '../hooks/useAppState'

type Props = {
  state: State
}

const CourseRegistrationStepOneClosedContent = ({ state }: Props) => {
  const { state: appState } = useAppState()
  const language = appState.selectedLanguage

  return (
    <Box fullWidth direction="row" align="center" gap="15px">
      {(!!state.name && !!state.email && !!state.phoneNumber) || !!state.obfuscatedEnrollment?.mainUser ? (
        <img src={iconCompleted} width={24} height={24} />
      ) : null}
      <GrooverText textKey="registrationHeadersAndStatusHeaderAttendee" language={language} />
    </Box>
  )
}

export default memo(CourseRegistrationStepOneClosedContent)
